export default __webpack_public_path__ + "static/media/marquee_square.75db4352.svg";